// Baselayer Results Explorer — match/hit status pill. Thin wrapper over the
// shared StatusBadge so the explorer reads one match vocabulary:
//   Exact → ok, Similar → progress, No Match → danger,
//   Hit → danger, No Hit → ok.

import { StatusBadge } from "@/design-system/components/ui";

export type MatchKind = "Exact" | "Similar" | "No Match" | "Hit" | "No Hit";

const TONE: Record<MatchKind, "ok" | "progress" | "danger"> = {
  Exact: "ok",
  Similar: "progress",
  "No Match": "danger",
  Hit: "danger",
  "No Hit": "ok",
};

/** Derives a match kind from a boolean (true → Exact, false → No Match, null → No Match). */
export function boolToMatch(value: boolean | null | undefined): MatchKind {
  return value ? "Exact" : "No Match";
}

/** Derives a hit kind from a count (>0 → Hit, else No Hit). */
export function countToHit(count: number | null | undefined): MatchKind {
  return (count ?? 0) > 0 ? "Hit" : "No Hit";
}

export function MatchBadge({ kind }: { kind: MatchKind }) {
  return <StatusBadge tone={TONE[kind]}>{kind}</StatusBadge>;
}
